import React, { memo } from 'react';
import useClearAllSmartviews from 'components/generic/smartview/shared/hooks/useClearAllSmartviews';
import MenuHeader, { type MenuHeaderProps } from 'components/sideMenu/components/Menu/components/MenuHeader';
import useFilters from '../../../shared/hooks/useFilters';

const FilterMenuHeader = ({ backButtonCallback, closeButtonCallback, ...restProps }: MenuHeaderProps) => {
    const { applyPendingFilters } = useFilters();
    const closeAllFiltersViews = useClearAllSmartviews();

    const handleClose = () => {
        applyPendingFilters();
        closeAllFiltersViews();
    };

    return (
        <MenuHeader
            {...restProps}
            backButtonCallback={backButtonCallback || undefined}
            closeButtonCallback={closeButtonCallback || handleClose}
            styling="White"
        />
    );
};

export default memo(FilterMenuHeader);
